import React from 'react';
import DatePickerHeader from './DatePickerHeader';
import DatePickerBody from './DatePickerBody';

const DatePicker = () => {
  return (
    <div>
      <DatePickerHeader />
      <DatePickerBody />
    </div>
  );
};

export default DatePicker;
